module.exports = __webpack_public_path__ + "static/media/rc_jing_qian.c5979fff.png";